import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import tdsIcon from 'assets/dashboard/tds.png';
import TdsConfigDashboard from './tdsConfigs';
import TdsDashboard from './tdsOffers';

export const TDS_ABSORPTION_RESOURCES = {
	tdsAbsorptionOffers: 'tdsAbsorptionOffers',
	tdsAbsorptionConfigs: 'tdsAbsorptionConfigs'
};

export const URL = {
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/tdsAbsorption/${TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers}`,
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionConfigs]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/tdsAbsorption/${TDS_ABSORPTION_RESOURCES.tdsAbsorptionConfigs}`
};

export const LABEL = {
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers]: 'TDS Absorption Offers',
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionConfigs]: 'TDS Absorption Configs'
};

export const COMPONENT = {
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers]: TdsDashboard,
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionConfigs]: TdsConfigDashboard
};

export const CONFIG_RESOURCE = {
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers]: 'TDS Absorption',
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionConfigs]: 'TDS Absorption'
};

export const GET_ACTION = {
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers]: {
		tdsAbsorptionOffers: 'getTDSAbsorptionActiveOffers',
		getTDSAbsorptionActiveOffers: 'getTDSAbsorptionActiveOffers',
		createTDSAbsorptionOffers: 'createTDSAbsorptionOffers',
		activateTDSAbsorptionOffers: 'activateTDSAbsorptionOffers',
		disableTDSAbsorptionOffers: 'disableTDSAbsorptionOffers',
		updateTDSAbsorptionOffers: 'updateTDSAbsorptionOffers'
	},
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionConfigs]: {
		tdsAbsorptionConfigs: 'getTDSAbsorptionConfigs',
		getTDSAbsorptionConfigs: 'getTDSAbsorptionConfigs',
		updateTDSAbsorptionConfigs: 'updateTDSAbsorptionConfigs'
	}
};

export const IMAGE_SOURCE = {
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionOffers]: tdsIcon,
	[TDS_ABSORPTION_RESOURCES.tdsAbsorptionConfigs]: tdsIcon
};

export type Record = {
	[key: string]: string | number | boolean;
};

export type SelectedUserType = {
	email: string;
	uid: string;
	phone: string;
	userSegment: string;
	addToStatic: boolean;
};

export const ADD_OFFER_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionOffers/create';
export const EDIT_OFFER_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionOffers/edit';
export const BACK_OFFER_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionOffers/list';
export const DETAILS_OFFER_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionOffers/tdsAbsorptionOfferDetails';
export const CLONE_OFFER_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionOffers/clone';
export const ACTIVATE_OFFER_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionOffers/activateOffer';
export const CREATE_OFFER_URI = '/dashboard/createTDSAbsorptionOffers/tdsAbsorption-tdsAbsorptionOffers-createTDSAbsorptionOffers';
export const ACTIVATE_OFFER_URI =
	'/dashboard/activateTDSAbsorptionOffers/tdsAbsorption-tdsAbsorptionOffers-activateTDSAbsorptionOffers';
export const UPDATE_OFFER_URI = '/dashboard/updateTDSAbsorptionOffers/tdsAbsorption-tdsAbsorptionOffers-updateTDSAbsorptionOffers';
export const DISABLE_OFFER_URI = '/dashboard/disableTDSAbsorptionOffers/tdsAbsorption-tdsAbsorptionOffers-disableTDSAbsorptionOffers';
export const GET_OFFER_URI = '/dashboard/getTDSAbsorptionActiveOffers/tdsAbsorption-tdsAbsorptionOffers-getTDSAbsorptionActiveOffers';
export const ADD_CONFIG_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionConfigs/create';
export const EDIT_CONFIG_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionConfigs/edit';
export const BACK_CONFIG_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionConfigs/list';
export const DETAILS_CONFIG_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionConfigs/tdsAbsorptionOfferDetails';
export const CLONE_CONFIG_ENDPOINT = '/dashboard/finance/tdsAbsorption/tdsAbsorptionConfigs/clone';
export const CREATE_CONFIG_URI =
	'/dashboard/createTDSAbsorptionConfigs/tdsAbsorption-tdsAbsorptionConfigs-createTDSAbsorptionConfigs';
export const UPDATE_CONFIG_URI = '/dashboard/updateTDSAbsorptionConfig/tdsAbsorption-tdsAbsorptionConfigs-updateTDSAbsorptionConfigs';
export const DISABLE_CONFIG_URI =
	'/dashboard/removeTDSAbsorptionConfigs/tdsAbsorption-tdsAbsorptionConfigs-removeTDSAbsorptionConfigs';
export const GET_CONFIG_URI = '/dashboard/getTDSAbsorptionConfig/tdsAbsorption-tdsAbsorptionConfigs-getTDSAbsorptionConfigs';

export const EN_LOCAL_DATA = 'en-IN';
